import { NECTAR_API_URL } from '@/env'
import { LOCAL_STORAGE_KEY_JWT } from '@/api'
import { routes } from '@/pages'
import axios, { AxiosRequestConfig } from 'axios'

const nectarClient = axios.create({ baseURL: NECTAR_API_URL })

nectarClient.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE_KEY_JWT)
    if (raw) {
      const token = JSON.parse(raw)
      config.headers.Authorization = `Bearer ${token}`
    }
  } catch (error) {
    console.error('Error reading token', error)
  }

  return config
})

nectarClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(LOCAL_STORAGE_KEY_JWT)
      window.location.replace(routes.login.path)
    }
    if (
      error.response?.status === 403 &&
      error.response?.data?.error === 'You are not allowed to access this resource'
    ) {
      localStorage.removeItem(LOCAL_STORAGE_KEY_JWT)
      window.location.replace(routes.ban.path)
    }
    return Promise.reject(error)
  }
)

export const nectarApi = {
  get: <T>(url: string, params?: Record<string, unknown>): Promise<T> =>
    nectarClient.get(url, { params }).then(({ data }) => data),
  post: <T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> =>
    nectarClient.post(url, data, config).then(({ data: res }) => res),
}
